import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, activeTab, onTabChange, onToggle }) => {
  const [collapsed, setCollapsed] = useState(!isOpen);

  const handleToggle = () => {
    setCollapsed(!collapsed);
    if (onToggle) onToggle();
  };

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`} id="sidebar">
      <div className="sidebar-header">
        <img src="/assets/logo.png" alt="Logo" className="sidebar-logo" />
        <button className="toggle-btn" onClick={handleToggle}>
          <span className="material-icons sidebar-item-icon-arrow">arrow_forward_ios</span>
        </button>
      </div>
      <ul>
        <li>
          <Link
            to="/"
            className={`sidebar-link ${activeTab === 'home' ? 'active' : ''}`}
            onClick={() => onTabChange('home')}
          >
            <i className="material-icons sidebar-item-icon">home</i>
            <span className="sidebar-item-text">Trang chủ</span>
          </Link>
        </li>
        <li>
          <Link
            to="/traffic-lights"
            className={`sidebar-link ${activeTab === 'traffic-lights' ? 'active' : ''}`}
            onClick={() => onTabChange('traffic-lights')}
          >
            <i className="material-icons sidebar-item-icon">traffic</i>
            <span className="sidebar-item-text">Danh sách đèn</span>
          </Link>
        </li>
        <li>
          <Link
            to="/map"
            className={`sidebar-link ${activeTab === 'map' ? 'active' : ''}`}
            onClick={() => onTabChange('map')}
          >
            <i className="material-icons sidebar-item-icon">map</i>
            <span className="sidebar-item-text">Xem bản đồ</span>
          </Link>
        </li>
        <li>
          <Link
            to="/settings"
            className={`sidebar-link ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => onTabChange('settings')}
          >
            <i className="material-icons sidebar-item-icon">settings</i>
            <span className="sidebar-item-text">Cài đặt</span>
          </Link>
        </li>
        <li>
          <Link
            to="/logout"
            className="sidebar-link"
            onClick={() => onTabChange('logout')}
          >
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;